import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AdminAccessrightService } from '../accessrightsadmin/accessrightsadmin.service';
import { User } from '../Master/user/user';
import { Accessrequest } from '../accessrequest/accessrequest';
import { Observable, timer } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";												
import { LocalService } from '../local.service';

@Component({
  selector: 'app-usermgt',
  templateUrl: './usermgt.component.html',
  styleUrls: ['./usermgt.component.css']
})
export class UsermgtComponent implements OnInit, OnDestroy {
  accessrequest: Accessrequest[];
  accesscount: number = 0;
  sendMenuId: number = 1;
  //timervalue: Observable<Number> = timer(0, 3000);
  timervalue: Observable<Number> = timer(0, 120000);
  //username = localStorage.getItem('username');
  username= this.localService.getJsonValue('username');
  //userrole=localStorage.getItem('userrole');
  userrole= this.localService.getJsonValue('userrole');
  subscription: any;
  activatedTab: string;
  _menuId: any; _actionRights: any; 

  constructor(private adminaccessrightService: AdminAccessrightService, 
    private route: ActivatedRoute, private SpinnerService: NgxSpinnerService, private router: Router,
    private toastr: ToastrService, private localService: LocalService
  ) {
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      //this.router.getCurrentNavigation()
      localStorage.setItem('UserManagement_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('UserManagement_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('User Management_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('User Management_action');
    }

  }

  ngOnInit() {
		 this.SpinnerService.show();		
     this.checkIsMenuMapped();   			   
    this.route.queryParams.subscribe((data) => {
      console.log(data);

      if (data && data['accesscount']) {
        this.accesscount = +data.accesscount
        if (this.accesscount > 0) {
          this.activatedTab = 'accessrequestTab';
          localStorage.setItem('UserManagement_menuid', data['menuid']);
          localStorage.setItem('UserManagement_action', data['action']);
          
        }
        else {
          this.activatedTab = 'userlistTab';
        }
      }
    });

    this.getAll();

    if (this.userrole == 'Admin') {
      this.subscription = this.timervalue.subscribe(() => {
        this.getAll();
      });
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedUserManagement");
    let data = arrays.find(ob => ob['name'] === 'User Management');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedUserManagement","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedUserManagement",null);
      this.router.navigate(["home"]);      
    }
  }

  getAll() {

    this.adminaccessrightService.Get().subscribe(res => {
      this.accessrequest = res;
      this.accesscount = this.accessrequest.length;

    }, error => { });

  }

  ngOnDestroy() {
    //console.log('timer destroyd');
    if (this.subscription != null && this.subscription != undefined) {
      this.subscription.unsubscribe();
    }
  }
}
